import {Link, useParams} from 'react-router-dom';


export const NoLongerAvailable = () => {
    const { id } = useParams(); // Get the ID from URL parameters

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
            <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full text-center">
                <h1 className="text-2xl font-bold text-red-600 mb-4">Access Denied</h1>

                <p className="mb-6 text-gray-700">
                    Order {id} is no longer available.
                </p>

                <div className="flex flex-col space-y-2">
                    <Link
                        to="/dashboard"
                        className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 transition duration-200"
                    >
                        Go to Dashboard
                    </Link>
                </div>
            </div>
        </div>
    );
};